export type CustomErrorParams = {
  message: string,
  statusText: string,
  statusCode: number,
};

class CustomError extends Error {
  constructor({ message, ...others }: CustomErrorParams) {
    super(message);
    Object.assign(this, { date: Date.now(), ...others });
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }
  }
}

export default CustomError;
